// src/Components/Footer/footerRouteSearch.ts
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import type { IntlShape } from "react-intl";
import { _eventBus } from "../../core/events/EventBus";
import { evtTree } from "../../Orchestrator/ConstantTree";
import { stopAction } from "../../Actions/LogicActions/Search/GetStopsAction";
import { getRecoilStateValue } from "../../Orchestrator/Recoils/Events/Recoil";
import { TrainTypeEnum } from "../../Orchestrator/Types/Enums/globalDefaultEnum";
import type { StationsListType, StationType } from "../../Orchestrator/Types/Index";

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Fire the same search the landing page fires, for a fixed route given by
 * backend station ids, defaulting to today (Asia/Dubai) and a single adult.
 *
 * The ids come straight from the CMS popular-trip `code`, which is the same
 * value GetStopsAction uses as each station's id — so we validate against the
 * loaded stops (fetching them once if needed) and no-op with a warning if
 * either id isn't a known bookable station.
 */
export async function fireRouteSearchByStationId(
  origin: string,
  destination: string,
  intl: IntlShape,
): Promise<void> {
  let stations = (getRecoilStateValue("stopsResponseAtom") as StationsListType) || [];
  if (stations.length === 0) {
    await stopAction.execute();
    stations = (getRecoilStateValue("stopsResponseAtom") as StationsListType) || [];
  }

  const isKnown = (id: string) => stations.some((s: StationType) => s.id === id);
  if (!origin || !destination || !isKnown(origin) || !isKnown(destination)) {
    console.warn(`[footer] cannot fire route ${origin} -> ${destination}: unknown station`);
    return;
  }

  _eventBus.emit({
    eventName: evtTree.SearchBar.SearchButton.Click,
    data: {
      departureTime: dayjs().tz("Asia/Dubai").format("YYYY-MM-DDTHH:mm:ss"),
      arrivalTime: null,
      origin,
      destination,
      totalPassengerCount: 1,
      passengerCounts: { adults: 1 },
      trainType: TrainTypeEnum.outbound,
      resetValue: true,
      fromShuttle: false,
      toShuttle: false,
      isFromPopUp: false,
      intl,
    },
  });
}
